/* Sucker Punch live tracker (sp-live). Sends anonymous funnel events to the live dashboard at sp.davisvaughn.com.
   No emails, no typed text, no IPs. Everything is wrapped so a failure here can never break the store.
   Opt a device out: open any page with ?sp_notrack=1 (undo with ?sp_notrack=0).
   Cookies: sp_vid (visitor, 1 year), sp_sid (session, 30 min sliding), sp_nt (opt-out). The checkout pixel reads them.
   Split tests: store/sp-ab.js (head) assigns versions; this file only reports them (see README, Split tests). */
(function(){
  "use strict";
  try {
    if (window.__spTrack) return; window.__spTrack = 1;
    if (window.Shopify && window.Shopify.designMode) return;
    /* per-store config comes from the script tag: data-ep (ingest URL) + data-clarity (Clarity project id) */
    var tag = document.currentScript || document.querySelector('script[src*="sp-track"]');
    var EP = (tag && tag.getAttribute("data-ep")) || "https://sp.davisvaughn.com/api/e";
    var CLARITY = (tag && tag.getAttribute("data-clarity")) || "ysps2toih7";
    var q = new URLSearchParams(location.search);
    var ck = function(n){ var m = document.cookie.match(new RegExp("(?:^|;\\s*)" + n + "=([^;]*)")); return m ? decodeURIComponent(m[1]) : ""; };
    var setCk = function(n, v, age){ document.cookie = n + "=" + encodeURIComponent(v) + "; path=/; max-age=" + age + "; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : ""); };
    if (q.get("sp_notrack") === "1") setCk("sp_nt", "1", 31536000);
    if (q.get("sp_notrack") === "0") setCk("sp_nt", "", 0);
    /* test mode (?sp_tt=1, kept 1 hour) is for deliberate tests: it beats the opt-out and the automation check,
       and those visits are hidden on the dashboard unless it is opened with ?test=1 */
    if (q.get("sp_tt") === "0") setCk("sp_tt", "", 0);
    var test = q.get("sp_tt") === "1" || (q.get("sp_tt") !== "0" && ck("sp_tt") === "1");
    if (test) setCk("sp_tt", "1", 3600);
    if (!test && ck("sp_nt") === "1") return;
    if (/bot|crawl|spider|headless|lighthouse/i.test(navigator.userAgent)) return;
    if (navigator.webdriver && !test) return;

    var rid = function(){ var a = "abcdefghijklmnopqrstuvwxyz0123456789", s = ""; for (var i = 0; i < 20; i++) s += a[Math.floor(Math.random() * a.length)]; return s; };
    var vid = ck("sp_vid"); if (!/^[a-z0-9]{20}$/.test(vid)) vid = rid();
    setCk("sp_vid", vid, 31536000);
    var sid = ck("sp_sid"), fresh = !/^[a-z0-9]{20}$/.test(sid);
    if (fresh) sid = rid();
    var touch = function(){ setCk("sp_sid", sid, 1800); };
    touch();

    /* first-touch context for this session (landing page, referrer, ad tags) */
    var ctx = null;
    try { var saved = JSON.parse(localStorage.getItem("sp_ctx") || "null"); if (saved && saved.sid === sid) ctx = saved; } catch (e){}
    if (!ctx){
      var host = ""; try { host = document.referrer ? new URL(document.referrer).hostname : ""; } catch (e){}
      ctx = { sid: sid, landing: location.pathname, ref: host === location.hostname ? "" : host,
        utm: { source: q.get("utm_source") || (q.get("fbclid") ? "facebook" : ""), medium: q.get("utm_medium") || "", campaign: q.get("utm_campaign") || "", content: q.get("utm_content") || "" } };
      try { localStorage.setItem("sp_ctx", JSON.stringify(ctx)); } catch (e){}
    }
    var dev = Math.min(window.innerWidth, screen.width || 9999) <= 760 ? "mobile" : (window.innerWidth <= 1100 ? "tablet" : "desktop");

    /* Microsoft Clarity (session recordings + heatmaps), project "Sucker Punch Energy". Tagged with the same short visitor id
       the live dashboard shows, so a visitor seen there can be looked up in Clarity. */
    try {
      (function(c, l, a, r, i, t, y){
        c[a] = c[a] || function(){ (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", CLARITY);
      window.clarity("set", "sp_visitor", sid.slice(-6));
      if (ctx.utm.content) window.clarity("set", "ad", ctx.utm.content);
    } catch (e){}
    /* Clarity's own user + session ids -> lets the dashboard link straight to this visit's recording */
    var clarityIds = function(){
      try {
        window.clarity("metadata", function(d){
          try {
            if (!d || !d.userId || !d.sessionId) return;
            var k = d.userId + "/" + d.sessionId;
            if (sessionStorage.getItem("sp_cl") === k) return;
            sessionStorage.setItem("sp_cl", k);
            ev("clarity", { u: String(d.userId).slice(0, 40), s: String(d.sessionId).slice(0, 40) }); flush();
          } catch (e){}
        }, false);
      } catch (e){}
    };

    var queue = [];
    function flush(){
      if (!queue.length) return;
      var body = JSON.stringify({ v: vid, s: sid, ctx: { path: location.pathname, landing: ctx.landing, ref: ctx.ref, utm: ctx.utm, dev: dev, t: test ? 1 : 0 }, ev: queue.splice(0, 40) });
      touch();
      try { if (navigator.sendBeacon && navigator.sendBeacon(EP, body)) return; } catch (e){}
      try { fetch(EP, { method: "POST", body: body, keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(function(){}); } catch (e){}
    }
    function ev(n, p){ queue.push({ n: n, t: Date.now(), p: p || {} }); if (queue.length >= 20) flush(); }
    setInterval(flush, 3000);
    document.addEventListener("visibilitychange", function(){ if (document.visibilityState === "hidden") flush(); });
    window.addEventListener("pagehide", flush);

    ev("page_view", { title: (document.title || "").slice(0, 80) });
    /* split tests: sp-ab.js (in <head>) already decided and applied each version. Report each assignment once per session
       ("ab" event: key + version) and tag the Clarity session so recordings / heatmaps can be filtered by version. Only counted visitors are reported. */
    try {
      var abx = window.__spAb;
      if (abx && abx.active && abx.active.length){
        var abd = null; try { abd = JSON.parse(sessionStorage.getItem("sp_abr") || "null"); } catch (e){}
        if (!abd || abd.sid !== sid) abd = { sid: sid, k: {} };
        var abt = [];
        abx.active.forEach(function(t){
          if (!t.counted) return;
          abt.push(t.k + ":" + t.v);
          try { window.clarity("set", "sp_test_" + t.k.slice(0, 30), t.v); } catch (e){}
          if (!abd.k[t.k]){ abd.k[t.k] = 1; ev("ab", { k: t.k, v: t.v }); }
        });
        if (abt.length){ try { window.clarity("set", "sp_ab", abt); } catch (e){} }
        try { sessionStorage.setItem("sp_abr", JSON.stringify(abd)); } catch (e){}
      }
    } catch (e){}
    /* PROPOSED 2026-10-09 (bot signals, not yet on the live themes). "hi" = the first TRUSTED input of the session (touch, pointer, key, wheel,
       mouse move; synthetic events have isTrusted false), sent once. "env" = a few browser facts, sent once per session. The dashboard's bot rules
       (lib/bots.js) already treat "hi" as proof of a person. Crawlers never produce trusted input. */
    try {
      var sget = function(k){ try { return sessionStorage.getItem(k); } catch (e){ return null; } }, sset = function(k, v){ try { sessionStorage.setItem(k, v); } catch (e){} };
      if (sget("sp_env") !== sid){
        sset("sp_env", sid);
        ev("env", { vis: document.visibilityState, tc: navigator.maxTouchPoints || 0, w: window.innerWidth, h: window.innerHeight, pl: navigator.plugins ? navigator.plugins.length : 0, lg: navigator.languages ? navigator.languages.length : 0, dpr: window.devicePixelRatio || 1 });
      }
      if (sget("sp_hi") !== sid){
        var HI = ["touchstart", "pointerdown", "keydown", "wheel", "mousemove"];
        var onHi = function(e){
          if (!e || !e.isTrusted) return;
          HI.forEach(function(n){ window.removeEventListener(n, onHi, true); });
          sset("sp_hi", sid); ev("hi", { t: e.type }); flush();
        };
        HI.forEach(function(n){ window.addEventListener(n, onHi, { capture: true, passive: true }); });
      }
    } catch (e){}
    flush();
    clarityIds();
    setInterval(function(){ if (document.visibilityState === "visible") ev("hb"); }, 15000);

    /* scroll depth */
    var marks = [25, 50, 75, 90], hit = {};
    window.addEventListener("scroll", function(){
      try {
        var h = document.documentElement.scrollHeight - window.innerHeight; if (h <= 0) return;
        var pct = (window.pageYOffset / h) * 100;
        marks.forEach(function(m){ if (pct >= m && !hit[m]){ hit[m] = 1; ev("scroll", { pct: m }); } });
      } catch (e){}
    }, { passive: true });

    /* sections seen; the buy box (join page #buy, or any add-to-cart form) counts as "reached the buy box" */
    if ("IntersectionObserver" in window){
      var seen = {}, buySeen = false;
      var io = new IntersectionObserver(function(list){
        list.forEach(function(en){
          if (!en.isIntersecting) return;
          var el = en.target, id = el.getAttribute("data-spt") || el.id;
          io.unobserve(el);
          if (id === "buy" || id === "atc-form"){ if (!buySeen){ buySeen = true; ev("buy_view", {}); } }
          if (id && id !== "atc-form" && !seen[id]){ seen[id] = 1; ev("sec", { id: id.slice(0, 40) }); }
        });
      }, { threshold: 0.25 });
      var arm = function(){
        Array.prototype.forEach.call(document.querySelectorAll("main section[id], .spj section[id], .sph section[id]"), function(s){ io.observe(s); });
        Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), function(f){ f.setAttribute("data-spt", "atc-form"); io.observe(f); });
      };
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arm); else arm();
    }

    /* 9-card pop-ups (homepage + join): read their state classes, no changes to their own code */
    var watchPops = function(){
      Array.prototype.forEach.call(document.querySelectorAll(".gpop"), function(pop){
        var st = { open: false, email: false, done: false, wasLocked: false };
        var gated = function(){ return !!pop.querySelector(".gpop-form"); };
        var check = function(){
          var c = pop.classList, where = /join/.test(location.pathname) ? "join" : (location.pathname === "/" ? "home" : "other");
          if (c.contains("is-open") && !st.open){ st.open = true; ev("pop_shown", { where: where, email_step: gated() }); }
          /* email accepted = the cards unlock (Sucker Punch adds is-unlocked; Buff Balm just drops is-locked) */
          if (c.contains("is-locked")) st.wasLocked = true;
          if (!st.email && gated() && (c.contains("is-phone") || c.contains("is-unlocked") || (st.wasLocked && c.contains("is-open") && !c.contains("is-locked")))){ st.email = true; ev("pop_email", { where: where }); }
          if (!st.phone && (c.contains("is-phoned") || c.contains("is-nophone"))){ st.phone = true; ev(c.contains("is-phoned") ? "pop_phone" : "pop_phone_skip", { where: where }); }
          if (c.contains("is-done") && !st.done){ st.done = true; ev("pop_picked3", { where: where }); }
          if (!c.contains("is-open") && st.open){ st.open = false; if (!st.done) ev("pop_closed", { where: where, stage: st.email || !gated() ? "cards" : "email" }); flush(); }
        };
        check();
        new MutationObserver(check).observe(pop, { attributes: true, attributeFilter: ["class"] });
      });
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchPops); else watchPops();

    /* clicks: flavor chips, buy buttons (membership vs one-time), checkout, everything else as a plain click */
    var txt = function(el){ return (el.getAttribute("aria-label") || el.innerText || el.value || "").replace(/\s+/g, " ").trim().slice(0, 60); };
    var secOf = function(el){ var s = el.closest && el.closest("section[id], [id^='shopify-section']"); return s ? (s.id || "").replace(/^shopify-section-(template--\d+__)?/, "").slice(0, 40) : ""; };
    document.addEventListener("click", function(e){
      try {
        var t = e.target; if (!t || !t.closest) return;
        var chip = t.closest(".chip[data-name]");
        if (chip){ ev("flavor_pick", { name: chip.getAttribute("data-name").slice(0, 40) }); return; }
        var el = t.closest("a, button, input[type=submit], [role=button], summary");
        if (!el) return;
        if (el.closest(".gc")) return; /* card flips are covered by pop_picked3 */
        var href = el.getAttribute("href") || "";
        if (href.indexOf("/cart/add") !== -1){
          var m = href.match(/[?&]id=(\d+)/);
          ev("buy_click", { plan: /selling_plan=\d/.test(href) ? "membership" : "onetime", variant: m ? m[1] : "", where: secOf(el), label: txt(el) }); flush(); return;
        }
        /* buy buttons that add by script instead of a link (Buff Balm box builder, product "add" buttons) */
        if (el.hasAttribute("data-bx-cta") || el.name === "add"){
          var lab = txt(el);
          ev("buy_click", { plan: /member|subscri/i.test(lab) ? "membership" : "onetime", variant: "", where: secOf(el), label: lab }); flush(); return;
        }
        if (href.indexOf("/checkout") !== -1 || el.name === "checkout"){ ev("checkout_click", { where: secOf(el) }); flush(); return; }
        var p = { t: txt(el), where: secOf(el) };
        if (href && href.charAt(0) !== "#"){ try { var u = new URL(href, location.href); p.h = (u.hostname === location.hostname ? "" : u.hostname) + u.pathname.slice(0, 80); } catch (err){} }
        else if (href) p.h = href.slice(0, 40);
        if (p.t || p.h) ev("click", p);
      } catch (err){}
    }, true);
    /* product-page forms */
    document.addEventListener("submit", function(e){
      try {
        var f = e.target;
        if (!f || !f.action || f.action.indexOf("/cart/add") === -1) return;
        var sp = f.querySelector('[name="selling_plan"]'), idEl = f.querySelector('[name="id"]');
        ev("buy_click", { plan: sp && sp.value ? "membership" : "onetime", variant: idEl ? String(idEl.value).slice(0, 20) : "", where: "product form", label: "" }); flush();
      } catch (err){}
    }, true);
  } catch (err){}
})();
